import React from 'react'

import loadingImage from './loading-circle.svg'

const LoadingSection = () => (
  <div style={{display: 'flex', justifyContent:'center',alignItems:'center',height:'100%'}}>
    <img src={loadingImage} alt="loading" />
  </div>
)

export default LoadingSection
